import { BaseModel } from "@/models/base.model"
import { ModelFactory } from "@/factories/model-factory"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { Location } from "@/models/location.model"
import { InstructionFeedbackActivityType } from "@/models/tenant_settings/instruction-feedback-activity-type.model"
import { InstructionFeedbackActivityTemplateProduct } from "@/models/instruction-feedback-activity-template-product.model"
import type { IInstructionFeedbackActivityTemplate } from "@/interfaces/api/instruction-feedback-activity-template.interface.ts"
import type { Moment } from "moment"

export class InstructionFeedbackActivityTemplate
  extends BaseModel
  implements IInstructionFeedbackActivityTemplate
{
  public static className = "InstructionFeedbackActivityTemplate"
  public static verboseName = "terugkoppelingsactiviteittemplate"

  public static override managedResolveFields = ["owner"]

  owner: KnownBusinessEntityContact
  type: InstructionFeedbackActivityType
  location?: Location
  products: InstructionFeedbackActivityTemplateProduct[]

  timeStart?: Moment | null
  timeEnd?: Moment | null
  customLocationText?: string | null
  body?: string | null

  constructor(template: IInstructionFeedbackActivityTemplate, managed = false) {
    super(template)

    this.owner = ModelFactory.childModel(KnownBusinessEntityContact, template.owner, managed)
    this.type = ModelFactory.childModel(InstructionFeedbackActivityType, template.type, managed)
    this.location = ModelFactory.childModel(Location, template.location, managed)
    this.products = ModelFactory.childModels(
      InstructionFeedbackActivityTemplateProduct,
      template.products,
      managed
    )
    this.timeStart = template.timeStart
    this.timeEnd = template.timeEnd
    this.customLocationText = template.customLocationText
    this.body = template.body
  }
}
